export default __webpack_public_path__ + "static/arrow-8d27c91283a66551f9ba8a4323e1ed76.gif";